import { useQueryPaymentsStatus } from "../../query/payments/queries";
import { selectorDefaultCurrency } from "../selectors/selectorDefaultCurrency";

export function useDefaultCurrency() {
  const paymentsStatusQuery = useQueryPaymentsStatus();
  return selectorDefaultCurrency(paymentsStatusQuery.data);
}
